import { World } from '../../src/index.js'

const W = window.innerWidth
const H = window.innerHeight
const CX = W / 2
const Z = 0

const world = new World()
const camera = world.createCamera()

world.camera = camera

await world.loader.load({
  'star': '../asset/image/star.png',
})

// ────────────────────────────────────────────────────────
// ① 일반 모드 — 왼쪽 절반에 파티클 에미터 3개 배치
// ────────────────────────────────────────────────────────

world.particleManager.create({
  name: 'star-slow',
  src: 'star',
  loop: true,
  lifespan: 2000,
  interval: 300,
  rate: 5,
  impulse: 0.1,
})

world.particleManager.create({
  name: 'star-burst',
  src: 'star',
  loop: true,
  lifespan: 1000,
  interval: 100,
  rate: 15,
  impulse: 0.4,
})

world.particleManager.create({
  name: 'star-large',
  src: 'star',
  loop: true,
  lifespan: 3000,
  interval: 500,
  rate: 3,
  impulse: 0.2,
})

const leftX = -CX / 2

// 에미터 ① — 느린 별 (가운데)
const p1 = world.createParticle({
  style: { width: 20, height: 20, blendMode: 'lighter' },
  transform: { position: { x: leftX, y: 0, z: Z } },
})
p1.attribute.src = 'star-slow'
p1.play()

// 에미터 ② — 빠른 버스트 (왼쪽)
const p2 = world.createParticle({
  style: { width: 12, height: 12, blendMode: 'lighter' },
  transform: { position: { x: leftX - 120, y: 60, z: Z } },
})
p2.attribute.src = 'star-burst'
p2.play()

// 에미터 ③ — 크고 느린 별 (오른쪽)
const p3 = world.createParticle({
  style: { width: 36, height: 36, blendMode: 'lighter' },
  transform: { position: { x: leftX + 120, y: -60, z: Z } },
})
p3.attribute.src = 'star-large'
p3.play()

// ────────────────────────────────────────────────────────
// ② strict 모드 — 오른쪽 절반, matter-js 물리 기반
// ────────────────────────────────────────────────────────


world.particleManager.create({
  name: 'star-strict',
  src: 'star',
  loop: true,
  lifespan: 3000,
  interval: 250,
  rate: 6,
  impulse: 0.3,
})

world.particleManager.create({
  name: 'star-strict-fast',
  src: 'star',
  loop: true,
  lifespan: 1500,
  interval: 150,
  rate: 10,
  impulse: 0.5,
})

const rightX = CX / 2

// strict 에미터 ① — 중앙
const pStrict = world.createParticle({
  style: { width: 18, height: 18, blendMode: 'lighter' },
  transform: { position: { x: rightX, y: -60, z: Z } },
  attribute: { strictPhysics: true, restitution: 0.6, friction: 0.05, density: 0.002, gravityScale: 0.8, collisionCategory: 0x0001, collisionMask: 0x0002 },
})
pStrict.attribute.src = 'star-strict'
pStrict.play()

// strict 에미터 ② — 오른쪽
const pStrictFast = world.createParticle({
  style: { width: 12, height: 12, blendMode: 'lighter' },
  transform: { position: { x: rightX + 100, y: 30, z: Z } },
  attribute: { strictPhysics: true, restitution: 0.4, friction: 0.1, density: 0.001, gravityScale: 1.2, collisionCategory: 0x0001, collisionMask: 0x0002 },
})
pStrictFast.attribute.src = 'star-strict-fast'
pStrictFast.play()

// static 바닥 (파티클 bounce)
const floorY = -(H / 2 - 200)
const floor = world.createRectangle({
  attribute: { name: 'floor', physics: 'static', collisionCategory: 0x0002 },
  style: { width: 600, height: 20, background: '#fff' },
  transform: { position: { x: rightX, y: floorY, z: Z } },
})
floor.style.opacity = 0.3

// ────────────────────────────────────────────────────────
// ③ 회전하는 객체 내부의 파티클 중력 테스트
// ────────────────────────────────────────────────────────

const rotatingBox = world.createRectangle({
  style: { width: 100, height: 100, borderWidth: 2, borderColor: '#aaa' },
  transform: { position: { x: 0, y: -H / 4, z: Z } }
})

const pGravity = world.createParticle({
  style: { width: 16, height: 16, blendMode: 'lighter' },
  transform: { position: { x: 0, y: 0, z: Z } },
  attribute: { strictPhysics: true, restitution: 0.5, friction: 0.1, density: 0.001, gravityScale: 1.0, collisionCategory: 0x0001, collisionMask: 0x0002 },
})
pGravity.attribute.src = 'star-strict'
rotatingBox.addChild(pGravity)
pGravity.play()

world.on('update', () => {
  rotatingBox.transform.rotation.z += 2
})

world.start()
